// <purpose>THE de-DE one-decimal number face — „10,7", „1.024,0" — shared by every surface that
// prints a measured quantity with one decimal (the descriptor pills' seconds, the attachment
// sizes). One helper, so the locale and the decimal rule can never drift between two copies.</purpose>
export const formatDeOneDecimal = (n: number): string =>
  n.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
